import { defineStore } from 'pinia';
import { STORE_KEY } from '@/config/storeKey';
import { computed, ref } from 'vue';
import { TRspGetBaseInfoByGame } from '@/service/baseinfo';
/**
 * 用户认证状态管理模块
 * 功能：管理用户基础信息、认证状态和权限数据
 */

export const useAuthStageStore = defineStore(STORE_KEY.GLOBAL.AUTH, () => {
  // 响应式数据：存储从接口获取的用户基础信息
  const baseInfo = ref<TRspGetBaseInfoByGame>();
  // 计算属性：从baseInfo中提取当前用户信息
  const currentUser = computed(() => baseInfo.value?.user);
  /**
   * 设置用户基础信息
   * @param info - 从接口获取的用户基础信息（TRspGetBaseInfoByGame类型）
   */
  const setBaseInfo = (info: TRspGetBaseInfoByGame) => {
    baseInfo.value = info;
  };

  return {
    currentUser,
    baseInfo,
    setBaseInfo,
  };
});
